import { useState } from 'react';
import styled from 'styled-components';
import MenuItem, { type MenuItemContent } from './MenuItem';

export interface MenuValue {
  title: string;
  subMenu: MenuItemContent[];
}

export interface RightRailNavigationProps {
  values: MenuValue[];
}

const RightRailNavigationWrapper = styled.ul`
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
`;

const RightRailNavigation = ({ values }: RightRailNavigationProps) => {
  const [activeMenu, setActiveMenu] = useState<number | null>(null);

  const handleShowHide = (index: number) => {
    const submenuOpened = activeMenu === index;
    setActiveMenu(submenuOpened ? null : index);
  };

  return (
    // biome-ignore lint/a11y/useSemanticElements: RightRailNavigationWrapper is a navigation element
    <RightRailNavigationWrapper
      role='navigation'
      data-cy='rightRailNavigation'
      aria-label='Rankings'
    >
      {values.map((menu, index) => (
        <MenuItem
          // eslint-disable-next-line react/no-array-index-key
          key={`${menu.title}-${index}`}
          menuTitle={menu.title}
          content={menu.subMenu}
          isMenuOpen={activeMenu === index}
          onClick={() => handleShowHide(index)}
          index={index}
        />
      ))}
    </RightRailNavigationWrapper>
  );
};

export default RightRailNavigation;
